import React from "react";

const UserInfoCell = ({ userId, username }) => {
  return (
    <td className="border border-slate-200 px-4 py-3">
      <div>
        <div className="font-semibold text-slate-800">{username}</div>
      </div>
    </td>
  );
};

export default UserInfoCell;